import { Action } from 'redux';
export const SPINNER_SHOW = 'SPINNER_SHOW';
export const SPINNER_HIDE = 'SPINNER_HIDE';
export const SPINNER_ACTIVATION = 'SPINNER_ACTIVATION';
export const SPINNER_PROGRESS = 'SPINNER_PROGRESS';

export type SpinnerActivationAction = Action & {
  active: boolean;
};

export type SpinnerProgressAction = Action & {
  progress: number;
};

export function showSpinner() {
  return {
    type: SPINNER_SHOW,
  } as Action;
}

export function hideSpinner() {
  return {
    type: SPINNER_HIDE,
  } as Action;
}

export function isCommunicatingWithServer(active: boolean): SpinnerActivationAction {
  return {
    type: SPINNER_ACTIVATION,
    active,
  };
}

export function changeProgress(progress: number): SpinnerProgressAction {
  return {
    type: SPINNER_PROGRESS,
    progress,
  };
}
